import React from "react";
import "./AppointmentDialogControls.css";
import Modal from "react-modal";
import moment from "moment";

// =======================================================
// RescheduleModal
// -------------------------------------------------------
// Displays the appointment rescheduling dialog.
//
// Responsibilities:
// - Show the selected appointment
// - Show the target artist and date
// - Edit the new appointment time
// - Submit or cancel the reschedule flow
// =======================================================

const RescheduleModal = ({
  isOpen,
  appointment,
  targetDay,
  rescheduleTime,
  setRescheduleTime,
  onSubmit,
  onCancel,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onCancel}
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={true}
      contentLabel="Termin umbuchen"
      className="reschedule-modal"
      overlayClassName="appointment-overlay"
    >
      <button type="button" className="appointment-dialog-close" onClick={onCancel} aria-label="Terminfenster schließen">✕</button>
      {appointment && targetDay && (
        <form
          onSubmit={onSubmit}
          className="reschedule-form"
        >
          <div className="reschedule-header">
            <div className="reschedule-title">
              Termin umbuchen
            </div>

            <div className="reschedule-date">
              {moment(targetDay.day).format("dddd")}
              <br />
              <span>
                {moment(targetDay.day).format(
                  "DD. MMMM YYYY"
                )}
              </span>
            </div>
          </div>

          <div className="reschedule-card">
            <div className="reschedule-label">
              Kunde
            </div>

            <div className="reschedule-client">
              {appointment.clientName}
            </div>
          </div>

          <div className="reschedule-arrow">↓</div>

          <div className="reschedule-card reschedule-target">
            <div className="reschedule-label">
              Neuer Termin
            </div>

            <div className="reschedule-target-row">
              <span>Künstler</span>
              <strong>{targetDay.artistName}</strong>
            </div>

            <div className="reschedule-target-row">
              <span>Datum</span>
              <strong>
                {moment(targetDay.day).format("DD.MM.YYYY")}
              </strong>
            </div>

            <div className="reschedule-target-row">
              <span>Zeit</span>

              <input
                type="time"
                value={rescheduleTime}
                onChange={(event) =>
                  setRescheduleTime(event.target.value)
                }
                required
              />
            </div>
          </div>

          <div className="reschedule-actions">
            <button
              type="button"
              className="reschedule-cancel"
              onClick={onCancel}
            >
              Abbrechen
            </button>

            <button
              type="submit"
              className="reschedule-confirm"
            >
              Umbuchen bestätigen
            </button>
          </div>
        </form>
      )}
    </Modal>
  );
};

export default RescheduleModal;